export default __webpack_public_path__ + "media/zurb/img/about/jon/jon-image1-3fc0697523965cf6360999fb5d9fd799.png";